import { observer } from 'mobx-react';
import * as React from 'react';
import LearningCollectionEditStore from '../../../Edit/Store';
import { ModifiableExperiencesContext } from '../../../Types';
import TableHead from './TableHead';
import TableHeadWithHandlers from './TableHeadWithHandlers';

interface Props {
  context: ModifiableExperiencesContext;
  store: LearningCollectionEditStore;
}

const CustomizeTableHead: React.FC<Props> = ({ context, store }) => {
  switch (context.kind) {
    case 'section-context':
      switch (context.section.resource.payload.learningDesignState) {
        case 'curated':
          return <TableHead />;
        case 'curated-custom':
        case 'custom':
        case 'empty':
        case 'blank':
        case 'build-your-own':
        case 'browse-all':
          return <TableHeadWithHandlers context={context} store={store} />;
      }
    case 'browse-all-experiences':
      return <TableHeadWithHandlers context={context} store={store} />;
  }
};

export default observer(CustomizeTableHead);
